<template>
  <div>
    <div id="opt_out_form">
        <Form />
    </div>
  </div>
</template>

<script>
import Form from "./components/Form.vue";

export default {
  name: "App",
  components: {
    Form
  }
};
</script>

<style lang="scss">
@import "css/_global.scss";
</style>